// Mock data for Alliance Solidarité

export const categories = {
  allianceHumaine: {
    name: 'Référent Alliance Humaine',
    color: '#8b5cf6', // violet from logo
    subcategories: [
      { id: 'alimentaire', name: 'Alimentaire', icon: 'UtensilsCrossed' },
      { id: 'bricolage', name: 'Bricolage', icon: 'Hammer' },
      { id: 'cours', name: 'Cours', icon: 'GraduationCap' },
      { id: 'education', name: 'Éducation', icon: 'BookOpen' },
      { id: 'espaces-verts', name: 'Espaces verts', icon: 'Trees' },
      { id: 'passions-hobbys', name: 'Passions / hobbys', icon: 'Heart' },
      { id: 'sante-bien-etre', name: 'Santé / Bien-être', icon: 'HeartPulse' },
      { id: 'services', name: 'Services', icon: 'Briefcase' },
      { id: 'vie-sociale', name: 'Vie sociale', icon: 'Users' },
      { id: 'membre-de', name: 'Membre de', icon: 'UserCheck' }
    ]
  },
  allianceEvasion: {
    name: 'Partenaire Alliance Evasion',
    color: '#ef4444', // red from logo
    subcategories: [
      { id: 'agriculture', name: 'Agriculture', icon: 'Sprout' },
      { id: 'habitat', name: 'Habitat', icon: 'Home' },
      { id: 'education-evasion', name: 'Education', icon: 'School' },
      { id: 'mobilite', name: 'Mobilité', icon: 'Car' },
      { id: 'sorties', name: 'Sorties', icon: 'Tickets' },
      { id: 'voyages', name: 'Voyages', icon: 'Plane' },
      { id: 'economie-finance', name: 'Economie/Finance', icon: 'Coins' }
    ]
  }
};

export const mockOffers = [
  {
    id: '1',
    title: 'Jardin Partagé du Quartier',
    description: 'Un espace vert communautaire où cultiver ensemble légumes et fleurs. Tous les mercredis et samedis.',
    category: 'allianceHumaine',
    subcategory: 'espaces-verts',
    address: '15 Rue des Jardins, 94230 Cachan',
    latitude: 48.7938,
    longitude: 2.3297,
    contact: {
      name: 'Marie Dupont',
      email: 'marie.dupont@example.com',
      phone: '06 12 34 56 78'
    },
    status: 'approved',
    createdAt: '2025-01-15',
    image: 'https://images.unsplash.com/photo-1464226184884-fa280b87c399?w=800'
  },
  {
    id: '2',
    title: 'Atelier de Bricolage Solidaire',
    description: 'Réparez vos objets avec l\'aide de bénévoles experts. Outils fournis, apportez vos objets à réparer.',
    category: 'allianceHumaine',
    subcategory: 'bricolage',
    address: '32 Allée Bajou, 94230 Cachan',
    latitude: 48.7895,
    longitude: 2.3310,
    contact: {
      name: 'Pierre Martin',
      email: 'pierre.martin@example.com',
      phone: '06 23 45 67 89'
    },
    status: 'approved',
    createdAt: '2025-01-20',
    image: 'https://images.unsplash.com/photo-1581783898377-1c85bf937427?w=800'
  },
  {
    id: '3',
    title: 'Distribution Alimentaire',
    description: 'Distribution gratuite de produits frais tous les jeudis de 14h à 17h. Fruits, légumes et produits de base.',
    category: 'allianceHumaine',
    subcategory: 'alimentaire',
    address: '8 Avenue de la République, 75011 Paris',
    latitude: 48.8636,
    longitude: 2.3798,
    contact: {
      name: 'Sophie Bernard',
      email: 'sophie.bernard@example.com',
      phone: '06 34 56 78 90'
    },
    status: 'approved',
    createdAt: '2025-01-18',
    image: 'https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=800'
  },
  {
    id: '4',
    title: 'Cours de Français pour Tous',
    description: 'Cours gratuits de français langue étrangère. Débutants et intermédiaires bienvenus. Lundi et jeudi soir.',
    category: 'allianceHumaine',
    subcategory: 'cours',
    address: '22 Rue Victor Hugo, 94230 Cachan',
    latitude: 48.7922,
    longitude: 2.3345,
    contact: {
      name: 'Julie Leroy',
      email: 'julie.leroy@example.com',
      phone: '06 45 67 89 01'
    },
    status: 'approved',
    createdAt: '2025-01-22',
    image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800'
  },
  {
    id: '5',
    title: 'Sortie Randonnée en Forêt',
    description: 'Randonnée découverte en forêt de Fontainebleau. Transport en commun organisé. Dimanche 10h-16h.',
    category: 'allianceEvasion',
    subcategory: 'sorties',
    address: 'Fontainebleau, 77300',
    latitude: 48.4084,
    longitude: 2.7010,
    contact: {
      name: 'Thomas Petit',
      email: 'thomas.petit@example.com',
      phone: '06 56 78 90 12'
    },
    status: 'approved',
    createdAt: '2025-01-25',
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=800'
  },
  {
    id: '6',
    title: 'Formation Agriculture Urbaine',
    description: 'Apprenez les techniques de permaculture et d\'agriculture urbaine. Formation gratuite sur 4 samedis.',
    category: 'allianceEvasion',
    subcategory: 'agriculture',
    address: '45 Rue des Champs, 94230 Cachan',
    latitude: 48.7910,
    longitude: 2.3280,
    contact: {
      name: 'Lucas Moreau',
      email: 'lucas.moreau@example.com',
      phone: '06 67 89 01 23'
    },
    status: 'approved',
    createdAt: '2025-01-12',
    image: 'https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?w=800'
  },
  {
    id: '7',
    title: 'Yoga et Méditation Gratuits',
    description: 'Séances de yoga et méditation en plein air. Débutants bienvenus. Mercredi 18h et samedi 10h.',
    category: 'allianceHumaine',
    subcategory: 'sante-bien-etre',
    address: 'Parc de Sceaux, 92330',
    latitude: 48.7782,
    longitude: 2.2981,
    contact: {
      name: 'Emma Dubois',
      email: 'emma.dubois@example.com',
      phone: '06 78 90 12 34'
    },
    status: 'approved',
    createdAt: '2025-01-10',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800'
  },
  {
    id: '8',
    title: 'Covoiturage Solidaire',
    description: 'Plateforme de covoiturage gratuit pour les trajets quotidiens. Partagez vos trajets, réduisez l\'empreinte carbone.',
    category: 'allianceEvasion',
    subcategory: 'mobilite',
    address: 'Cachan - Paris - Banlieue Sud',
    latitude: 48.7945,
    longitude: 2.3315,
    contact: {
      name: 'Nicolas Lambert',
      email: 'nicolas.lambert@example.com',
      phone: '06 89 01 23 45'
    },
    status: 'pending',
    createdAt: '2025-01-28',
    image: 'https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=800'
  }
];

export const mockStats = {
  totalOffers: 156,
  activeUsers: 342,
  pendingOffers: 12,
  approvedThisMonth: 28
};

export const mockUser = {
  id: 'user-1',
  name: 'Antoine Cuttitta',
  email: 'antoine.cuttitta@live.fr',
  role: 'owner',
  avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Antoine'
};

export const mockUsers = [
  mockUser,
  {
    id: 'user-2',
    name: 'Sophie Martin',
    email: 'sophie.martin@example.com',
    role: 'admin',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sophie'
  },
  {
    id: 'user-3',
    name: 'Lucas Dubois',
    email: 'lucas.dubois@example.com',
    role: 'moderator',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Lucas'
  },
  {
    id: 'user-4',
    name: 'Marie Leroy',
    email: 'marie.leroy@example.com',
    role: 'user',
    avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Marie'
  }
];